// Blog page load more articles script

// append articles to the articles container
const articlesContainer = document.querySelector("[data-blog-articles-container]");
const loadMoreButton = document.querySelector("[data-load-more]");
let nextURL = articlesContainer.dataset.nextUrl;
loadMoreButton.addEventListener("click", () => {
  fetch(nextURL).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }
    return response.text();
  }).then((html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    nextURL = doc.querySelector("[data-blog-articles-container]").dataset.nextUrl;
    if (!nextURL) {
      loadMoreButton.remove();
    }
    const allArticles = doc.querySelectorAll("[data-blog-article]");
    allArticles.forEach((article) => {
      articlesContainer.append(article);
    })
  }).catch((error) => {
    console.log(error);
  })
})
